var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('n-list',{attrs:{"value":"expenseCategories","text":"開支分類","fields":_vm.fields,"items":_vm.expenseCategories}})}
var staticRenderFns = []

export { render, staticRenderFns }